__turbopack_context__.v({
  "avatar": "native-class-card-module__W35C0G__avatar",
  "body": "native-class-card-module__W35C0G__body",
  "card": "native-class-card-module__W35C0G__card",
  "category": "native-class-card-module__W35C0G__category",
  "details": "native-class-card-module__W35C0G__details",
  "duration": "native-class-card-module__W35C0G__duration",
  "eligibility": "native-class-card-module__W35C0G__eligibility",
  "footer": "native-class-card-module__W35C0G__footer",
  "heading": "native-class-card-module__W35C0G__heading",
  "image": "native-class-card-module__W35C0G__image",
  "players": "native-class-card-module__W35C0G__players",
  "select": "native-class-card-module__W35C0G__select",
  "status": "native-class-card-module__W35C0G__status",
  "summary": "native-class-card-module__W35C0G__summary",
  "time": "native-class-card-module__W35C0G__time",
  "title": "native-class-card-module__W35C0G__title",
  "trainer": "native-class-card-module__W35C0G__trainer",
  "waitlist": "native-class-card-module__W35C0G__waitlist",
});
